import { EntityStatus } from '../../../../Entity'
import { MATCH_ELIGIBILITY_STATUSES } from '../../../RentalPortalMatch'

function RentalPortalApplicantsEligibilityFilterListItemContent({ value }) {
  return (
    <EntityStatus id={value?.value} statuses={MATCH_ELIGIBILITY_STATUSES} />
  )
}

export default RentalPortalApplicantsEligibilityFilterListItemContent
